// import React, { useContext, useEffect, useState } from "react";
// import { DataContext } from "../Screenss/DataContext";

// const TransportSection = () => {
//   const primaryColor = "rgb(0, 111, 47)"; // DPS Green
//   const { data } = useContext(DataContext);
//   const [current, setCurrent] = useState(0);

//   // 🔥 API se Transport ki images filter karein (Agar category bani ho)
//   const transportImages = data.filter(
//     (item) => item.category === "schooltransport" || item.category === "schoolbus"
//   );

//   // Fallback images agar API mein data na ho
//   const fallbackImages = [
//     "https://images.unsplash.com/photo-1574629810360-7efbbe195018?auto=format&fit=crop&w=1200&q=80",
//     "https://images.unsplash.com/photo-1556448851-9359658cb406?auto=format&fit=crop&w=1200&q=80"
//   ];

//   const displayImages = transportImages.length > 0 ? transportImages.map(i => i.full_url) : fallbackImages;

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrent((prev) => (prev === displayImages.length - 1 ? 0 : prev + 1));
//     }, 4000);
//     return () => clearInterval(interval);
//   }, [displayImages]);

//   const facilities = [
//     { icon: "🚌", title: "Modern Fleet", desc: "GPS enabled buses for real-time tracking." },
//     { icon: "🛡️", title: "Safety First", desc: "CCTV surveillance and female attendants in every bus." },
//     { icon: "📍", title: "Wide Coverage", desc: "Connecting all major areas of Ladwa and nearby villages." },
//     { icon: "👨‍✈️", title: "Trained Drivers", desc: "Experienced and verified staff for secure travel." }
//   ];

//   return (
//     <div style={styles.page}>
      
//       {/* 🚍 HERO SLIDER */}
//       <section style={styles.hero}>
//         <div style={styles.heroWrap}>
//           <img src={displayImages[current]} alt="School Bus" style={styles.heroImage} />
        
//         </div>
//       </section>

//       {/* 🏗️ FACILITIES GRID */}
//       <section style={styles.content}>
//         <div style={styles.headerArea}>
//           <h2 style={{ ...styles.heading, color: primaryColor }}>Transport Facilities</h2>
//           <div style={{ ...styles.line, backgroundColor: primaryColor }} />
//         </div>

//         <div className="transport-grid" style={styles.grid}>
//           {facilities.map((f, i) => (
//             <div key={i} className="t-card" style={styles.card}>
//               <span style={styles.icon}>{f.icon}</span>
//               <h3 style={{ color: primaryColor, margin: "10px 0" }}>{f.title}</h3>
//               <p style={styles.cardText}>{f.desc}</p>
//             </div>
//           ))}
//         </div>

//         {/* 📋 TRANSPORT RULES CARD */}
//         <div style={styles.rulesBox}>
//           <h3 style={{ marginBottom: "15px" }}>Transport Policy</h3>
//           <ul style={styles.list}>
//             <li>Buses will ply on fixed routes only.</li>
//             <li>Students must be at the stop 5 minutes before time.</li>
//             <li>Identity cards are mandatory for bus entry.</li>
//           </ul>
//         </div>
//       </section>

//       <style>{`
//         .transport-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 20px;
//           margin-bottom: 50px;
//         }
//         .t-card { transition: 0.3s; cursor: pointer; }
//         .t-card:hover { 
//           transform: translateY(-10px); 
//           box-shadow: 0 15px 35px rgba(0,0,0,0.1);
//           border-bottom: 4px solid ${primaryColor};
//         }
//         @media (max-width: 768px) {
//           .hero-wrap { height: 350px !important; }
//           .main-title { font-size: 2rem !important; }
//         }
//       `}</style>
//     </div>
//   );
// };

// const styles = {
//   page: { backgroundColor: "#fff", fontFamily: "'Poppins', sans-serif" },
//     hero: {
//     width: "100%",
//     marginTop: "120px",
//   },
//    heroWrap: {
//     position: "relative",
//     width: "100%",
//     height: "560px",
//     overflow: "hidden",
//     marginTop:140
//   },
//   heroImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     display: "block",
//   },
  
//   overlay: { position: "absolute", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center" },
//   heroText: { textAlign: "center", color: "#fff" },
//   mainTitle: { fontSize: "3rem", fontWeight: "900", margin: 0 },
//   subTitle: { fontSize: "1.2rem", fontWeight: "300" },
  
//   dots: { position: "absolute", bottom: "20px", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "8px" },
//   dot: { height: "8px", borderRadius: "10px", transition: "0.3s" },

//   content: { padding: "80px 20px", maxWidth: "1200px", margin: "auto" },
//   headerArea: { textAlign: "center", marginBottom: "50px" },
//   heading: { fontSize: "2.5rem", fontWeight: "800", marginBottom: "10px" },
//   line: { width: "60px", height: "4px", margin: "auto", borderRadius: "10px" },

//   card: { background: "#f9f9f9", padding: "30px", borderRadius: "20px", textAlign: "center", border: "1px solid #eee" },
//   icon: { fontSize: "3rem" },
//   cardText: { color: "#666", fontSize: "0.95rem", lineHeight: "1.6" },

    
//   rulesBox: {  background: "rgb(0, 111, 47)", color: "#fff", padding: "40px", borderRadius: "25px", marginTop: "30px" },
//   list: { paddingLeft: "20px", lineHeight: "2" }
// };

// export default TransportSection;

import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../Screenss/DataContext";

const TransportSection = () => {
  const primaryColor = "rgb(0, 111, 47)";
  const { data } = useContext(DataContext);
  const [current, setCurrent] = useState(0);

  const transportImages = data.filter(
    (item) =>
      item.category === "schooltransport" ||
      item.category === "schoolbus"
  );

  const fallbackImages = [
    "https://images.unsplash.com/photo-1574629810360-7efbbe195018",
    "https://images.unsplash.com/photo-1556448851-9359658cb406",
  ];

  const displayImages =
    transportImages.length > 0
      ? transportImages.map((i) => i.full_url)
      : fallbackImages;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === displayImages.length - 1 ? 0 : prev + 1
      );
    }, 4000);
    return () => clearInterval(interval);
  }, [displayImages]);

  const facilities = [
    { icon: "🚌", title: "Modern Fleet", desc: "GPS enabled buses for real-time tracking." },
    { icon: "🛡️", title: "Safety First", desc: "CCTV surveillance and female attendants in every bus." },
    { icon: "📍", title: "Wide Coverage", desc: "Connecting all major areas of Ladwa and nearby villages." },
    { icon: "👨‍✈️", title: "Trained Drivers", desc: "Experienced and verified staff for secure travel." }
  ];

  return (
    <div style={styles.page}>

      {/* 🚍 HERO */}
      <section style={styles.hero}>
        <div style={styles.heroWrap}>
          <img
            src={displayImages[current]}
            alt="School Transport"
            style={styles.heroImage}
          />

          <div style={styles.overlay}>
            <h1 style={styles.heroTitle}>Safe & Reliable Transport</h1>
          </div>
        </div>
      </section>

      {/* 🏗️ CONTENT */}
      <section style={styles.content}>
        <div style={styles.headerArea}>
          <h2 style={{ ...styles.heading, color: primaryColor }}>
            Transport Facilities
          </h2>
          <div style={{ ...styles.line, backgroundColor: primaryColor }} />
        </div>

        {/* GRID */}
        <div style={styles.grid}>
          {facilities.map((f, i) => (
            <div key={i} style={styles.card}>
              <span style={styles.icon}>{f.icon}</span>
              <h3 style={styles.cardTitle}>{f.title}</h3>
              <p style={styles.cardText}>{f.desc}</p>
            </div>
          ))}
        </div>

        {/* RULES */}
        <div style={styles.rulesBox}>
          <h3 style={styles.rulesTitle}>Transport Policy</h3>
          <ul style={styles.list}>
            <li>Buses will ply on fixed routes only.</li>
            <li>Students must be at the stop 5 minutes before time.</li>
            <li>Identity cards are mandatory for bus entry.</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TransportSection;

/* 🔥 STYLES */
const styles = {
  page: {
    backgroundColor: "#fff",
    fontFamily: "sans-serif",
  },

  /* HERO */
  hero: {
    width: "100%",
    marginTop: "100px",
  },

  heroWrap: {
    position: "relative",
    width: "100%",
    height: "clamp(220px, 45vw, 520px)", // 🔥 responsive height
    overflow: "hidden",
  },

  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(rgba(0,0,0,0.5), rgba(0,111,47,0.6))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  heroTitle: {
    color: "#fff",
    fontSize: "clamp(20px, 5vw, 42px)",
    fontWeight: "800",
    textAlign: "center",
    padding: "0 10px",
  },

  /* CONTENT */
  content: {
    padding: "clamp(40px, 6vw, 80px) 15px",
    maxWidth: "1200px",
    margin: "auto",
  },

  headerArea: {
    textAlign: "center",
    marginBottom: "40px",
  },

  heading: {
    fontSize: "clamp(22px, 4vw, 34px)",
    fontWeight: "800",
  },

  line: {
    width: "60px",
    height: "4px",
    margin: "10px auto",
    borderRadius: "10px",
  },

  /* GRID */
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "20px",
    marginBottom: "50px",
  },

  card: {
    background: "#f9f9f9",
    padding: "clamp(20px, 4vw, 30px)",
    borderRadius: "18px",
    textAlign: "center",
    transition: "0.3s",
    border: "1px solid #eee",
  },

  cardTitle: {
    margin: "10px 0",
    color: "rgb(0,111,47)",
    fontWeight: "700",
  },

  icon: {
    fontSize: "2.5rem",
  },

  cardText: {
    color: "#666",
    fontSize: "clamp(13px, 2vw, 15px)",
    lineHeight: "1.6",
  },

  /* RULES */
  rulesBox: {
    background: "rgb(0, 111, 47)",
    color: "#fff",
    padding: "clamp(20px, 4vw, 40px)",
    borderRadius: "20px",
  },

  rulesTitle: {
    marginBottom: "15px",
    fontSize: "clamp(16px, 3vw, 20px)",
  },

  list: {
    paddingLeft: "20px",
    lineHeight: "1.9",
    fontSize: "clamp(13px, 2vw, 15px)",
  },
};